import React, { useMemo } from "react";
import { AppsData } from "./apps.data";
import { DisplayData, DisplayDataProps, DisplayDataWidget, translateLabelForData } from "@me8eon/data";
import { useAttributeValueComponents, useRenderers } from "@me8eon/renderers";
import { SimpleWidget } from "@me8eon/simple_widget";
import { ThemedIcon } from "@me8eon/icons";
import AddRemoveDashboardButton from "./add.remove.dashboard.button";

export const AppDisplay: DisplayData<AppsData> =
    ({ rootId, id, data }: DisplayDataProps<AppsData>) => {
        const { H1WithIconAndUrl, Url } = useRenderers();
        const { Text, DataLayout } = useAttributeValueComponents();
        const newRootId = `${rootId}.${id}`;
        const issueSummaryAndUrl = useMemo(() =>
            ({ url: data.target, title: data.title, icon: () => <ThemedIcon name="app" /> }), [data.target, data.title]);
        return <DataLayout rootId={newRootId} layout={[1, 1, 1]}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", paddingTop: "8px" }}>
                <H1WithIconAndUrl rootId={newRootId} attribute={translateLabelForData("name")} value={issueSummaryAndUrl} />
                <AddRemoveDashboardButton appData={data} />
            </div>
            <Text rootId={id} attribute={translateLabelForData("source")} value="apps" />
            <Url rootId={id} attribute={translateLabelForData("url")} value={data.target} />
        </DataLayout>;
    };

export const OneLineAppDisplay: DisplayData<AppsData> =
    ({ data, listItemClicked }: DisplayDataProps<AppsData>) => {
        const { SearchListItem } = useRenderers();
        const issueSummaryAndUrl = useMemo(() =>
        ({
            title: data.title,
            icon: () => <ThemedIcon name="app" />,
            onClick: () => { listItemClicked && listItemClicked(data.title) }
        }), [data.title]);
        return (
            <SearchListItem key={data.title} rootId={data.title} attribute={translateLabelForData('name')} value={issueSummaryAndUrl} />
        )
    }

export const SimpleAppWidget: DisplayDataWidget<AppsData> =
    SimpleWidget(
        ["issue", "summary", "status"],
        ["title"],
        []);

